// Star Arts Form JavaScript
;(function () {
  "use strict";
  
  var StarArtsForm = function () {
    var $form = $('#art-form');
    var $editor = $('#editor');
    var $wordCount = $('.word-count');
    var $charCount = $('.char-count');
    var $submitBtn = $('.submit-btn');
    var $titleField = $('input[name="star_art[title]"]');
    var $slugField = $('input[name="star_art[slug]"]');
    var $hiddenEditor = $('#hidden_editor');
    var autoSaveTimer;
    var $autoSaveIndicator;
    
    var initForm = function() {
      if ($submitBtn.length) {
        $submitBtn.on('click', function() {
          var $btn = $(this);
          $btn.addClass('loading');
          $btn.html('<i class="fas fa-spinner fa-spin"></i> Processing...');
        });
      }
    };
    
    var initEditor = function() {
      if (!$editor.length) return;
      
      // Make editor contenteditable if it's not already
      if (!$editor.attr('contenteditable')) {
        $editor.attr('contenteditable', true);
      }
      
      var updateCounts = function() {
        var text = $editor.text() || $editor.html();
        var words = text.trim().split(/\s+/).filter(function(word) { 
          return word.length > 0; 
        }).length;
        var chars = text.length;
        
        if ($wordCount.length) $wordCount.text(words + ' words');
        if ($charCount.length) $charCount.text(chars + ' characters');
        
        // Update hidden field for form submission
        if ($hiddenEditor.length) {
          $hiddenEditor.val($editor.html());
        }
      };
      
      // Update counts on input
      $editor.on('input paste keyup', updateCounts);
      
      // Initial count
      updateCounts();
      
      // Add placeholder text if editor is empty
      if (!$editor.text().trim()) {
        $editor.html('<p style="color: #999; font-style: italic;">Start writing your artwork content here...</p>');
        $editor.one('focus', function() {
          if ($editor.html().includes('Start writing')) {
            $editor.html('');
          }
        });
      }
    };
    
    var initAutoSave = function() {
      // Create auto-save indicator
      $autoSaveIndicator = $('<div class="auto-save-indicator"><i class="fas fa-save"></i> Auto-saved</div>');
      $('body').append($autoSaveIndicator);
      
      var showAutoSaveIndicator = function() {
        $autoSaveIndicator.addClass('show');
        setTimeout(function() {
          $autoSaveIndicator.removeClass('show');
        }, 2000);
      };
      
      // Auto-save on form changes
      $form.on('input', function() {
        clearTimeout(autoSaveTimer);
        autoSaveTimer = setTimeout(function() {
          console.log('Auto-saving form data...');
          showAutoSaveIndicator();
          
          // Here you could implement actual auto-save to server
          // For now, we'll just save to localStorage
          var formData = new FormData($form[0]);
          var data = {};
          for (var pair of formData.entries()) {
            data[pair[0]] = pair[1];
          }
          localStorage.setItem('star_art_draft', JSON.stringify(data));
        }, 3000);
      });
      
      // Restore draft on page load
      var draft = localStorage.getItem('star_art_draft');
      if (draft && !$titleField.val()) {
        try {
          var data = JSON.parse(draft);
          Object.keys(data).forEach(function(key) {
            var $field = $form.find('[name="' + key + '"]');
            if ($field.length && !$field.val()) {
              $field.val(data[key]);
            }
          });
        } catch (e) {
          console.error('Error restoring draft:', e);
        }
      }
    };
    
    var initValidation = function() {
      $form.on('submit', function(e) {
        var $requiredFields = $form.find('[required]');
        var isValid = true;
        var $firstInvalidField = null;
        
        $requiredFields.each(function() {
          var $field = $(this);
          if (!$field.val().trim()) {
            $field.addClass('is-invalid');
            isValid = false;
            if (!$firstInvalidField) {
              $firstInvalidField = $field;
            }
          } else {
            $field.removeClass('is-invalid');
          }
        });
        
        if (!isValid) {
          e.preventDefault();
          
          // Show error message
          var $errorDiv = $('<div class="alert alert-danger"><i class="fas fa-exclamation-triangle"></i> Please fill in all required fields marked with an asterisk (*).</div>');
          
          var $formHeader = $form.find('.form-header');
          if ($formHeader.length) {
            $formHeader.append($errorDiv);
          }
          
          // Scroll to first invalid field
          if ($firstInvalidField) {
            $firstInvalidField[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
            $firstInvalidField.focus();
          }
          
          // Remove error message after 5 seconds
          setTimeout(function() {
            if ($errorDiv.parent().length) {
              $errorDiv.remove();
            }
          }, 5000);
        }
      });
      
      // Real-time validation
      $form.find('[required]').each(function() {
        var $field = $(this);
        
        $field.on('blur', function() {
          if (!$field.val().trim()) {
            $field.addClass('is-invalid');
          } else {
            $field.removeClass('is-invalid');
          }
        });
        
        $field.on('input', function() {
          if ($field.val().trim()) {
            $field.removeClass('is-invalid');
          }
        });
      });
    };
    
    var initSlugGeneration = function() {
      if (!$titleField.length || !$slugField.length) return;
      
      var $pageTitleField = $('input[name="star_art[page_title]"]');
      var $urlPreview = $('.slug-preview');
      
      var generateSlug = function(text) {
        return text
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '')
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-|-$/g, '');
      };
      
      var updateUrlPreview = function() {
        var slug = $slugField.val() || 'your-artwork-url-slug';
        if ($urlPreview.length) {
          $urlPreview.text(slug);
        }
      };
      
      $titleField.on('input', function() {
        var title = $(this).val();
        var slug = generateSlug(title);
        
        // Only auto-generate if slug field is empty or was auto-generated
        if (!$slugField.val() || $slugField.data('autoGenerated')) {
          $slugField.val(slug);
          $slugField.data('autoGenerated', true);
          updateUrlPreview();
        }
        
        // Auto-set page title if it's empty or was auto-generated
        if (!$pageTitleField.val() || $pageTitleField.data('autoGenerated')) {
          $pageTitleField.val(title);
          $pageTitleField.data('autoGenerated', true);
        }
      });
      
      // Clear auto-generated flag when user manually edits slug
      $slugField.on('input', function() {
        $slugField.removeData('autoGenerated');
        updateUrlPreview();
      });
      
      // Clear auto-generated flag when user manually edits page title
      $pageTitleField.on('input', function() {
        $pageTitleField.removeData('autoGenerated');
      });
      
      // Add slug validation
      $slugField.on('blur', function() {
        var slug = $slugField.val();
        if (slug && !/^[a-z0-9-]+$/.test(slug)) {
          $slugField.addClass('is-invalid');
          $slugField[0].setCustomValidity('Slug can only contain lowercase letters, numbers, and hyphens');
        } else {
          $slugField.removeClass('is-invalid');
          $slugField[0].setCustomValidity('');
        }
      });
      
      // Initial URL preview
      updateUrlPreview();
    };
    
    var initEditorToolbar = function() {
      if (!$editor.length) return;
      
      // Add basic formatting shortcuts
      $editor.on('keydown', function(e) {
        // Bold: Ctrl+B
        if (e.ctrlKey && e.key === 'b') {
          e.preventDefault();
          document.execCommand('bold', false, null);
        }
        
        // Italic: Ctrl+I
        if (e.ctrlKey && e.key === 'i') {
          e.preventDefault();
          document.execCommand('italic', false, null);
        }
        
        // Underline: Ctrl+U
        if (e.ctrlKey && e.key === 'u') {
          e.preventDefault();
          document.execCommand('underline', false, null);
        }
        
        // Escape key to exit fullscreen
        if (e.key === 'Escape' && $('.content-editor-container').hasClass('fullscreen')) {
          toggleFullscreen();
        }
      });
      
      // Add paste handling to clean up formatting
      $editor.on('paste', function(e) {
        e.preventDefault();
        var text = (e.originalEvent || e).clipboardData.getData('text/plain');
        document.execCommand('insertText', false, text);
      });
    };
    
    var initMaximizeEditor = function() {
      var $maximizeBtn = $('.maximize-editor-btn');
      var $editorContainer = $('.content-editor-container');
      
      if (!$maximizeBtn.length) return;
      
      var toggleFullscreen = function() {
        if ($editorContainer.hasClass('fullscreen')) {
          // Exit fullscreen
          $editorContainer.removeClass('fullscreen');
          $('body').removeClass('editor-fullscreen');
          $maximizeBtn.removeClass('maximized');
          $maximizeBtn.find('i').removeClass('fa-compress').addClass('fa-expand');
          $maximizeBtn.attr('title', 'Maximize Editor');
          
          // Restore scroll position
          $('html, body').scrollTop($editorContainer.data('scroll-position') || 0);
        } else {
          // Enter fullscreen
          $editorContainer.addClass('fullscreen');
          $('body').addClass('editor-fullscreen');
          $maximizeBtn.addClass('maximized');
          $maximizeBtn.find('i').removeClass('fa-expand').addClass('fa-compress');
          $maximizeBtn.attr('title', 'Minimize Editor');
          
          // Store scroll position
          $editorContainer.data('scroll-position', $('html, body').scrollTop());
          
          // Focus on editor
          setTimeout(function() {
            $editor.focus();
          }, 100);
        }
      };
      
      // Make toggleFullscreen available globally
      window.toggleFullscreen = toggleFullscreen;
      
      $maximizeBtn.on('click', function(e) {
        e.preventDefault();
        toggleFullscreen();
      });
      
      // Handle window resize
      $(window).on('resize', function() {
        if ($editorContainer.hasClass('fullscreen')) {
          // Ensure editor takes full viewport
          $editor.css('height', 'calc(100vh - 120px)');
        }
      });
    };
    
    var initEventListeners = function() {
      initForm();
      // initEditor();
      // initAutoSave();
      initValidation();
      initSlugGeneration();
      initEditorToolbar();
      initMaximizeEditor();
    };
    
    this.configureForm = function() {
      initEventListeners();
    };
  };
  
  $(document).ready(function() {
    if ($('#art-form').length) {
      var starArtsForm = new StarArtsForm();
      starArtsForm.configureForm();
    }
  });
})(); 